import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";
import { api } from "@/lib/api";

const Diamond = () => <span className="mx-8 inline-block w-1.5 h-1.5 rotate-45 bg-sky-400/80 align-middle" />;

const PulseDot = () => (
  <span className="relative flex h-2 w-2 shrink-0">
    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
    <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
  </span>
);

const StatusChip = () => {
  const [uptime, setUptime] = useState(null);

  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get("/systems/status");
        if (alive) setUptime(data.uptime_pct);
      } catch {
        /* keep last known figure */
      }
    };
    tick();
    const id = setInterval(tick, 10000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  return (
    <div
      className="relative z-10 flex items-center gap-2.5 shrink-0 h-full pl-6 sm:pl-12 pr-5 bg-[#0B0D12] border-r border-[#282E3F]"
      data-testid="home-status-chip"
    >
      <PulseDot />
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-emerald-400 whitespace-nowrap hidden sm:inline">
        All Systems Operational
      </span>
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-emerald-400 whitespace-nowrap sm:hidden">
        Operational
      </span>
      <span className="font-mono text-[10px] tracking-[0.15em] text-sky-400/90 whitespace-nowrap" data-testid="status-chip-uptime">
        {uptime ? `${uptime}%` : "…"}
      </span>
    </div>
  );
};

const EditorialMarquee = () => (
  <section className="border-y border-[#282E3F] bg-[#12151E]/70 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex items-stretch h-14">
      <StatusChip />
      <div className="flex-1 flex items-center overflow-hidden">
        <Marquee speed={32} gradient={false} pauseOnHover>
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400 whitespace-nowrap">{item}</span>
              <Diamond />
            </span>
          ))}
        </Marquee>
      </div>
    </div>
  </section>
);

export default EditorialMarquee;
